<template>
  <canvas class="noise" ref="noise"></canvas>
</template>

<script>
export default {
  name: 'BgNoise',

  mounted() {
    this.init();
    this.setup();

    this.$eventHub.$on('windowResized', this.setup);
  },

  methods: {
    init() {
      this.canvas = this.$refs.noise;
      this.ctx = this.canvas.getContext('2d');

      this.noiseData = [];
      this.frame = 0;

      this.loopTimeout = null;
      this.resizeThrottle = null;

      this.setup();
    },

    setup() {
      this.noiseData = [];
      this.canvas.width = window.innerWidth;
      this.canvas.height = window.innerHeight;

      for (let i = 0; i < 10; i += 1) {
        this.createNoise();
      }

      this.loop();
    },

    createNoise() {
      const idata = this.ctx.createImageData(window.innerWidth, window.innerHeight);
      const buffer32 = new Uint32Array(idata.data.buffer);
      const len = buffer32.length;

      for (let i = 0; i < len; i += 1) {
        if (Math.random() < 0.5) {
          buffer32[i] = 0xff000000;
        }
      }

      this.noiseData.push(idata);
    },

    paintNoise() {
      if (this.frame === 9) {
        this.frame = 0;
      } else {
        this.frame = this.frame + 1;
      }

      this.ctx.putImageData(this.noiseData[this.frame], 0, 0);
    },

    loop() {
      this.paintNoise(this.frame);

      this.loopTimeout = window.setTimeout(() => {
        this.loop = this.loop.bind(this);
        window.requestAnimationFrame(this.loop);
      }, (3000 / 25));
    },

    destroy() {
      this.reset();

      this.loopTimeout = 0;

      document.removeChild(this.$el);
    },
  },
};
</script>

<style scoped>
.noise {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  opacity: 0.03;
  pointer-events: none;

  z-index: 300;
}
</style>



// WEBPACK FOOTER //
// src/components/BgNoise.vue